/* Minty Honors and brand showcase. Reads the public brand index and decorates brand pages. */
(function () {
  'use strict';
  var runtimeEl = document.querySelector('script[data-minty-brand-runtime]');
  if (!runtimeEl) return;
  var runtime;
  try { runtime = JSON.parse(runtimeEl.textContent); } catch (e) { return; }
  var HONORS_URL = '/pages/minty-honors';
  var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  var SHORT = { Monday: 'Mon', Tuesday: 'Tue', Wednesday: 'Wed', Thursday: 'Thu', Friday: 'Fri', Saturday: 'Sat', Sunday: 'Sun' };
  var ENTERTAINMENT = ['Karaoke', 'DJ', 'Live Music', 'Live Band', 'Bingo', 'Trivia', 'Comedy', 'Open Mic', 'Pool Tournament', 'Food Truck'];

  var ICONS = {
    trophy: '<path d="M7 4h10v3a5 5 0 0 1-10 0V4Z"/><path d="M7 6H4.5a2.5 2.5 0 0 0 2.6 3.4M17 6h2.5a2.5 2.5 0 0 1-2.6 3.4"/><path d="M12 12v4M8.5 20h7M9.5 16h5v4h-5z"/>',
    stage: '<path d="M4 20V9l8-5 8 5v11"/><path d="M4 20h16M9 20v-5h6v5"/><circle cx="12" cy="10" r="1.6"/>',
    check: '<path d="M12 3l2.2 1.6 2.7-.1.8 2.6 2.2 1.6-.9 2.5.9 2.5-2.2 1.6-.8 2.6-2.7-.1L12 21l-2.2-1.6-2.7.1-.8-2.6-2.2-1.6.9-2.5-.9-2.5 2.2-1.6.8-2.6 2.7.1Z"/><path d="m8.8 12.2 2.2 2.2 4.3-4.6"/>',
    calendar: '<rect x="4" y="5.5" width="16" height="14" rx="2"/><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4"/><path d="m9.3 14.6 1.8 1.8 3.6-3.7"/>',
    mic: '<rect x="9" y="3.5" width="6" height="10" rx="3"/><path d="M6 11a6 6 0 0 0 12 0M12 17v3.5M9 20.5h6"/>',
    book: '<path d="M4.5 5.5c2.8-1 5.3-.8 7.5.8v13c-2.2-1.6-4.7-1.8-7.5-.8v-13ZM19.5 5.5c-2.8-1-5.3-.8-7.5.8v13c2.2-1.6 4.7-1.8 7.5-.8v-13Z"/>',
    landmark: '<path d="M3.5 9 12 4l8.5 5h-17Z"/><path d="M5.5 9v8M9.8 9v8M14.2 9v8M18.5 9v8M3.5 20h17M4.5 17h15"/>',
    handshake: '<path d="m3 12 4-4 3 1 2-1.5L17 8l4 4"/><path d="m7 8 5 5a1.4 1.4 0 0 0 2-2l-2.5-2.5"/><path d="M5 14l3 3m1.5-4.5 3 3M3 12l5 5.5c.8.8 2 .8 2.8 0M21 12l-4.5 4.5"/>',
    home: '<path d="M4 11 12 4.5 20 11"/><path d="M6 9.5V20h12V9.5M10 20v-5.5h4V20"/>',
    route: '<circle cx="6" cy="18" r="2.2"/><circle cx="18" cy="6" r="2.2"/><path d="M8.2 18H15a3 3 0 0 0 0-6H9a3 3 0 0 1 0-6h6.8"/>'
  };
  function icon(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || ICONS.check) + '</svg>';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function el(html) { var t = document.createElement('template'); t.innerHTML = html.trim(); return t.content.firstElementChild; }
  function brandUrl(h) { return '/pages/brand/' + encodeURIComponent(h); }
  function eventUrl(h) { return '/pages/events/' + encodeURIComponent(h); }

  function fmtTime(hhmm) {
    if (!hhmm) return '';
    var p = String(hhmm).split(':'); var h = +p[0], m = +p[1] || 0;
    var ap = h >= 12 ? 'PM' : 'AM'; var hh = h % 12 || 12;
    return hh + (m ? ':' + (m < 10 ? '0' + m : m) : '') + ' ' + ap;
  }
  function fmtRange(a) {
    var s = fmtTime(a.start_time); if (!s) return '';
    if (a.duration_hours) {
      var p = String(a.start_time).split(':'); var mins = (+p[0]) * 60 + (+p[1] || 0) + Math.round(a.duration_hours * 60);
      var wraps = mins >= 24 * 60;
      mins = mins % (24 * 60); var e = fmtTime(Math.floor(mins / 60) + ':' + (mins % 60));
      if (e === '12 AM') e = 'midnight';
      if (!wraps && s.slice(-2) === e.slice(-2)) s = s.slice(0, -3);
      return s + '–' + e;
    }
    return s;
  }
  function shortTitle(a, brandName) {
    var t = a.title || '';
    var cut = t.lastIndexOf(' at ');
    if (cut > 0) t = t.slice(0, cut);
    t = t.replace(/(,\s*|\s+on\s+)(mondays?|tuesdays?|wednesdays?|thursdays?|fridays?|saturdays?|sundays?)(\s+nights?)?$/i, '')
         .replace(/,?\s+(friday|saturday|sunday|monday|tuesday|wednesday|thursday)\s+nights?$/i, '')
         .replace(/,?\s+\d{1,2}(-|–)\d{1,2}\s*(am|pm)\s*m-f$/i, '')
         .replace(/,?\s+(monday to friday|m-f)$/i, '');
    return t.trim() || a.title;
  }
  function isActive(a, today) {
    if (a.residency_end_date && a.residency_end_date < today) return false;
    if (a.publication_status && a.publication_status !== 'ready') return false;
    return true;
  }
  function laToday() {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'long' }).formatToParts(new Date());
    var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
    return { iso: o.year + '-' + o.month + '-' + o.day, weekday: o.weekday };
  }

  function honorsHtml(list) {
    var trophies = list.filter(function (a) { return a.kind === 'trophy'; });
    var badges = list.filter(function (a) { return a.kind !== 'trophy'; });
    var h = '<section class="mh mh-honors" aria-labelledby="mh-honors-title"><div class="mh-honors-head"><h2 class="mh-honors-title" id="mh-honors-title">Honors on Minty</h2>' +
      '<a class="mh-honors-how" href="' + HONORS_URL + '">How badges and trophies are earned</a></div>';
    if (trophies.length) {
      h += '<div class="mh-plaques">' + trophies.map(function (a) {
        return '<a class="mh-plaque" href="' + HONORS_URL + '#' + esc(a.key) + '" title="' + esc(a.description) + '"><span class="mh-plaque-icon">' + icon(a.icon) + '</span><span><span class="mh-plaque-title">' + esc(a.title) + '</span>' +
          (a.detail ? '<span class="mh-plaque-detail">' + esc(a.detail) + '</span>' : '') + '</span></a>';
      }).join('') + '</div>';
    }
    if (badges.length) {
      h += '<ul class="mh-pins">' + badges.map(function (a) {
        var detail = a.detail;
        if (a.key === 'story_told') detail = 'Minty Press';
        return '<li><a class="mh-pin' + (a.key === 'fresh_schedule' ? ' mh-pin--fresh' : '') + '" href="' + HONORS_URL + '#' + esc(a.key) + '" title="' + esc(a.description) + '"><span class="mh-pin-icon">' + icon(a.icon) + '</span><span class="mh-pin-text"><span class="mh-pin-title">' + esc(a.title) + '</span>' +
          (detail ? '<span class="mh-pin-detail">' + esc(detail) + '</span>' : '') + '</span></a></li>';
      }).join('') + '</ul>';
    }
    return h + '</section>';
  }

  function weekHtml(entry, apps, today) {
    var weekly = apps.filter(function (a) { return a.recurrence && a.recurrence !== 'None' && (a.days || []).length; });
    if (weekly.length < 2) return '';
    var everyday = weekly.filter(function (a) { return a.days.length >= 4 && (a.event_types || []).indexOf('Specials') > -1; });
    var nightly = weekly.filter(function (a) { return everyday.indexOf(a) < 0; });
    var multiPlace = weekly.some(function (a) { return a.place_handle !== weekly[0].place_handle; });
    var cols = DAYS.map(function (d) {
      var items = nightly.filter(function (a) { return a.days.indexOf(d) > -1; })
        .sort(function (x, y) { return String(x.start_time || '99').localeCompare(String(y.start_time || '99')); });
      var isToday = d === today.weekday;
      var body = items.length ? items.map(function (a) {
        var special = (a.event_types || []).every(function (t) { return ENTERTAINMENT.indexOf(t) < 0; });
        var meta = fmtRange(a); if (multiPlace && a.place_name) meta += (meta ? ', ' : '') + a.place_name;
        return '<a class="mh-night' + (special ? ' mh-night--special' : '') + '" href="' + eventUrl(a.handle) + '"><span class="mh-night-title">' + esc(shortTitle(a, entry.name)) + '</span>' +
          (meta ? '<span class="mh-night-time">' + esc(meta) + '</span>' : '') + '</a>';
      }).join('') : '<span class="mh-day-empty" aria-label="Nothing regular listed">–</span>';
      return '<div class="mh-day' + (isToday ? ' mh-day--today' : '') + (items.length ? '' : ' mh-day--empty') + '"><div class="mh-day-name"><span>' + SHORT[d] + '<span class="visually-hidden">' + d.slice(3) + '</span></span>' +
        (isToday ? '<span class="mh-tonight">Today</span>' : '') + '</div><div>' + body + '</div></div>';
    }).join('');
    var ev = '';
    if (everyday.length) {
      var groups = {}, gorder = [];
      everyday.forEach(function (a) {
        var d = a.days; var range = d.length === 5 && d.indexOf('Saturday') < 0 && d.indexOf('Sunday') < 0 ? 'Weekdays' : d.length === 7 ? 'Every day' : d.map(function (x) { return SHORT[x]; }).join(', ');
        if (!groups[range]) { groups[range] = []; gorder.push(range); }
        groups[range].push('<a href="' + eventUrl(a.handle) + '">' + esc(shortTitle(a, entry.name)) + '</a> ' + esc(fmtRange(a)));
      });
      ev = '<p class="mh-everyday">' + gorder.map(function (g) { return '<strong>' + g + ':</strong> ' + groups[g].join(', '); }).join('<br>') + '</p>';
    }
    var oneOffs = apps.filter(function (a) { return (!a.recurrence || a.recurrence === 'None') && a.date_time && a.date_time.slice(0, 10) >= today.iso; })
      .sort(function (x, y) { return x.date_time.localeCompare(y.date_time); }).slice(0, 4);
    var up = '';
    if (oneOffs.length) {
      up = '<div class="mh-upcoming">' + oneOffs.map(function (a) {
        var dt = new Date(a.date_time);
        var mon = dt.toLocaleString('en-US', { month: 'short', timeZone: 'America/Los_Angeles' });
        var day = dt.toLocaleString('en-US', { day: 'numeric', timeZone: 'America/Los_Angeles' });
        var wk = dt.toLocaleString('en-US', { weekday: 'long', timeZone: 'America/Los_Angeles' });
        var tm = dt.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/Los_Angeles' }).replace(':00', '');
        return '<a class="mh-up" href="' + eventUrl(a.handle) + '"><span class="mh-up-date"><b>' + esc(day) + '</b><span>' + esc(mon) + '</span></span><span><span class="mh-up-title">' + esc(shortTitle(a, entry.name)) + '</span><br><span class="mh-up-meta">' + esc(wk + ', ' + tm) + '</span></span></a>';
      }).join('') + '</div>';
    }
    var name = entry.name;
    return '<section class="mh mh-block" aria-labelledby="mh-week-title"><h2 class="mh-h2" id="mh-week-title">A week at ' + esc(name) + '</h2>' +
      '<p class="mh-sub">Every regular night, with who runs it. Tap a night for times, directions and a calendar link.</p>' +
      '<div class="mh-week">' + cols + '</div>' + ev + up + '</section>';
  }

  function lineupHtml(entry, apps, index, byHandle) {
    var people = {}; var order = [];
    apps.forEach(function (a) {
      (a.hosts || []).forEach(function (h) {
        if (!h.handle || h.handle === entry.handle) return;
        if (!people[h.handle]) { people[h.handle] = { handle: h.handle, name: h.name, days: [], types: [] }; order.push(h.handle); }
        var p = people[h.handle];
        if (a.recurrence && a.recurrence !== 'None') (a.days || []).forEach(function (d) { if (p.days.indexOf(d) < 0) p.days.push(d); });
        (a.event_types || []).forEach(function (t) { if (p.types.indexOf(t) < 0) p.types.push(t); });
      });
    });
    var community = ((entry.showcase || {}).community || []).filter(function (c) { return byHandle[c.handle]; });
    if (order.length + community.length < 2) return '';
    function card(handle, role) {
      var b = byHandle[handle] || {}; var name = b.name || (people[handle] || {}).name || handle;
      var img = b.image ? '<img class="mh-avatar" src="' + esc(b.image + (b.image.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy" width="44" height="44">' : '<span class="mh-avatar" aria-hidden="true">' + esc(name.charAt(0)) + '</span>';
      var hon = (b.achievements || []).slice(0, 3).map(function (x) { return '<span class="mh-mini">' + icon(x.icon) + esc(x.title) + '</span>'; }).join('');
      return '<li><a class="mh-person" href="' + brandUrl(handle) + '">' + img + '<span><span class="mh-person-name">' + esc(name) + '</span><span class="mh-person-role">' + esc(role) + '</span>' +
        (hon ? '<span class="mh-person-honors">' + hon + '</span>' : '') + '</span></a></li>';
    }
    order.sort(function (x, y) {
      var dx = DAYS.indexOf(people[x].days[0]); var dy = DAYS.indexOf(people[y].days[0]);
      return (dx < 0 ? 9 : dx) - (dy < 0 ? 9 : dy);
    });
    var cards = order.map(function (h) {
      var p = people[h];
      var days = p.days.sort(function (a, b) { return DAYS.indexOf(a) - DAYS.indexOf(b); }).map(function (d) { return d + 's'; });
      var what = p.types.filter(function (t) { return t !== 'Specials'; })[0] || '';
      var role = days.length ? (days.length > 2 ? days.length + ' nights a week' : days.join(' and ')) : 'Special events';
      if (what) role += ', ' + what.toLowerCase().replace('dj', 'DJ').replace('food truck', 'food truck');
      return card(h, role);
    }).concat(community.map(function (c) { return card(c.handle, c.label || ''); }));
    return '<section class="mh mh-block" aria-labelledby="mh-lineup-title"><h2 class="mh-h2" id="mh-lineup-title">The people behind the nights</h2>' +
      '<p class="mh-sub">Each host, performer and partner here has their own Minty page with their other gigs.</p><ul class="mh-lineup">' + cards.join('') + '</ul></section>';
  }

  function storyHtml(entry) {
    var s = entry.showcase || {};
    if (!s.quote && !(s.timeline || []).length) return '';
    var story = (entry.achievements || []).filter(function (a) { return a.key === 'story_told'; })[0];
    var post = story && (entry.posts || []).filter(function (p) { return p.title === story.detail; })[0];
    var left = '';
    if (s.quote) {
      left = '<blockquote class="mh-quote"><p>“' + esc(s.quote) + '”</p><footer>' + esc(s.quote_by || '') +
        (post ? '. <a href="' + esc(post.url) + '">Read the full story in Minty Press</a>' : '') + '</footer></blockquote>';
    }
    if ((s.welcome || []).length) {
      left += '<div class="mh-welcome"><h3>' + esc(s.welcome_title || 'Good to know') + '</h3><ul>' + s.welcome.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul></div>';
    }
    var right = (s.timeline || []).length ? '<ol class="mh-timeline">' + s.timeline.map(function (t) {
      return '<li class="mh-tl"><span class="mh-tl-year">' + esc(t.year) + '</span><span class="mh-tl-text">' + esc(t.text) + '</span></li>';
    }).join('') + '</ol>' : '';
    return '<section class="mh mh-block" aria-labelledby="mh-story-title"><h2 class="mh-h2" id="mh-story-title">' + esc(s.story_title || 'The story') + '</h2>' +
      '<p class="mh-sub">In the owners’ own words.</p><div class="mh-story"><div>' + left + '</div><div>' + right + '</div></div></section>';
  }

  function homeVenueHtml(entry, byHandle) {
    var hv = (entry.showcase || {}).home_venue; var v = hv && byHandle[hv];
    if (!v) return '';
    return '<a class="mh mh-home" href="' + brandUrl(hv) + '"><span>Home venue: <b>' + esc(v.name) + '</b>' + (v.tagline ? '<br><span style="font-size:12px;color:#56635b">' + esc(v.tagline) + '</span>' : '') + '</span></a>';
  }

  function compactSchedule(entry) {
    var wrap = document.getElementById('brand-appearances');
    if (!wrap || (entry.places || []).length !== 1) return;
    var place = entry.places[0];
    wrap.classList.add('mh-compact-own');
    var h = wrap.querySelector('#section-appearances');
    if (h && /^events$/i.test(h.textContent.trim())) h.textContent = 'Full schedule';
    wrap.querySelectorAll('.minty-event-card').forEach(function (card) {
      if (!card.querySelector('.minty-event-address')) return;
      var addr = card.querySelector('.minty-event-address').textContent;
      if (place.street_address && addr.indexOf(place.street_address) < 0) return;
      card.querySelectorAll('a,p').forEach(function (n) {
        var t = n.textContent.trim();
        if (n.closest('.minty-event-actions') || n.closest('.minty-event-hosts')) return;
        if (t === place.name || /^Venue: /.test(t)) {
          var host = n.tagName === 'A' && n.parentElement !== card ? n.parentElement : n;
          host.setAttribute('data-mh-own-place', '');
        }
      });
    });
  }


  function laOffset(dateStr) {
    try {
      var d = new Date(dateStr + 'T12:00:00Z');
      var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', timeZoneName: 'shortOffset' }).formatToParts(d);
      var o = (p.filter(function (x) { return x.type === 'timeZoneName'; })[0] || {}).value || 'GMT-8';
      var m = o.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
      if (!m) return '-08:00';
      return m[1] + (m[2].length < 2 ? '0' + m[2] : m[2]) + ':' + (m[3] || '00');
    } catch (e) { return '-08:00'; }
  }
  function addDays(iso, n) {
    var d = new Date(iso + 'T12:00:00Z'); d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }
  function eventsJsonLd(entry, apps, today) {
    var out = [];
    var WD = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    function push(a, dateIso, time) {
      var start = dateIso + (time ? 'T' + time + ':00' + laOffset(dateIso) : '');
      var ev = {
        '@type': 'Event', name: a.title, url: location.origin + eventUrl(a.handle),
        startDate: start,
        eventStatus: 'https://schema.org/EventScheduled',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
        location: { '@type': 'Place', name: a.place_name, address: { '@type': 'PostalAddress', streetAddress: a.place_street_address || undefined, addressLocality: a.place_city || undefined, addressRegion: a.place_state || 'CA', postalCode: a.place_zip_code || undefined, addressCountry: 'US' } },
        performer: (a.hosts || []).map(function (h) { return { '@type': 'PerformingGroup', name: h.name, url: location.origin + brandUrl(h.handle) }; }),
        organizer: { '@type': 'Organization', name: a.place_name, url: location.origin + '/pages/place/' + encodeURIComponent(a.place_handle) }
      };
      if (a.description) ev.description = String(a.description).slice(0, 500);
      if (entry.image) ev.image = entry.image;
      if (time && a.duration_hours) {
        var t = new Date(dateIso + 'T' + time + ':00' + laOffset(dateIso)); t = new Date(t.getTime() + a.duration_hours * 3600000);
        ev.endDate = t.toISOString().replace('.000Z', 'Z');
      }
      out.push(ev);
    }
    apps.forEach(function (a) {
      if (!a.place_name) return;
      var ets = a.event_types || [];
      if (ets.length && ets.every(function (t) { return t === 'Specials'; })) return;
      if (a.recurrence && a.recurrence !== 'None' && (a.days || []).length) {
        for (var i = 0; i < 14; i++) {
          var iso = addDays(today.iso, i);
          var wd = WD[new Date(iso + 'T12:00:00Z').getUTCDay()];
          if (a.days.indexOf(wd) > -1 && (!a.residency_end_date || iso <= a.residency_end_date) && (!a.residency_start_date || iso >= a.residency_start_date)) { push(a, iso, a.start_time); break; }
        }
      } else if (a.date_time) {
        var local = new Date(a.date_time).toLocaleString('sv-SE', { timeZone: 'America/Los_Angeles' }).replace(' ', 'T').slice(0, 16);
        if (local.slice(0, 10) >= today.iso) push(a, local.slice(0, 10), local.slice(11, 16));
      } else if (a.event_date && a.event_date >= today.iso) {
        push(a, a.event_date, '');
      }
    });
    out.sort(function (x, y) { return x.startDate.localeCompare(y.startDate); });
    return out.slice(0, 20);
  }

  function waitFor(sel, ms) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function tick() {
        var n = document.querySelector(sel);
        if (n && n.querySelector('.minty-event-card, h2')) return resolve(n);
        if (Date.now() - t0 > ms) return resolve(document.querySelector(sel));
        setTimeout(tick, 250);
      })();
    });
  }

  fetch(runtime.indexUrl, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (index) {
    if (!index) return;
    var byHandle = {};
    Object.keys(index).forEach(function (k) { var v = index[k]; if (v && v.handle) byHandle[v.handle] = v; });
    var entry = byHandle[runtime.handle];
    if (!entry) return;
    var today = laToday();
    var apps = (entry.appearances || []).filter(function (a) { return isActive(a, today.iso); });
    try {
      var evs = eventsJsonLd(entry, apps, today);
      if (evs.length) {
        var ld = document.createElement('script'); ld.type = 'application/ld+json'; ld.setAttribute('data-minty-events-ld', '');
        ld.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': evs });
        document.head.appendChild(ld);
      }
    } catch (e) {}
    var head = document.querySelector('.mt-brand-profile-head');
    if (!head) return;
    var anchor = head;
    var home = homeVenueHtml(entry, byHandle);
    if (home) { var hn = el(home); anchor.after(hn); anchor = hn; }
    if ((entry.achievements || []).length) { var hs = el(honorsHtml(entry.achievements)); anchor.after(hs); anchor = hs; }
    var wk = weekHtml(entry, apps, today);
    if (wk) { var wn = el(wk); anchor.after(wn); }
    var story = storyHtml(entry); var lineup = lineupHtml(entry, apps, index, byHandle);
    if (story || lineup) {
      waitFor('#brand-appearances', 8000).then(function (sched) {
        var target = sched || document.querySelector('.brand-page');
        var frag = document.createDocumentFragment();
        if (story) frag.appendChild(el(story));
        if (lineup) frag.appendChild(el(lineup));
        if (sched) sched.parentNode.insertBefore(frag, sched); else target.appendChild(frag);
      });
    }
    waitFor('#brand-appearances', 8000).then(function (sched) { if (sched) setTimeout(function () { compactSchedule(entry); }, 300); });
  }).catch(function () {});
})();
